import { EntityMultiValuedListMoreItem } from '../../Entity'

import BuildingGroupIcon from '../../../icons/buildings-group.svg'

function BuildingGroupMultiValuedListMoreItem(props) {
  return <EntityMultiValuedListMoreItem {...props} Icon={BuildingGroupIcon} />
}

export default BuildingGroupMultiValuedListMoreItem
